// extracted by mini-css-extract-plugin
module.exports = {"item":"RadioGroup_item__f0YXE","radio":"RadioGroup_radio__hDuD4","radioIndicator":"RadioGroup_radioIndicator__fuuhq"};